export default "<ion-app  [dir]=\"rtlSide\">\n  <app-sign-comp-in-toolbar></app-sign-comp-in-toolbar>\n</ion-app>\n"